var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"t-single-column",class:[_vm.headerStyleClass]},[_c('div',{staticClass:"t-single-column__header"},[_vm._t("header")],2),_c('div',{staticClass:"t-single-column__main"},[_vm._t("main")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }